import * as React from 'react';

import type {Breadcrumb} from 'shells/numbered-breadcrumbs/numbered-breadcrumbs';
import {NumberedBreadcrumbs} from 'shells/numbered-breadcrumbs/numbered-breadcrumbs';

import styles from './prepare-to-send-breadcrumbs.module.css';

type Props = {
    prepareViewButtonsDisabled: boolean;
    audienceSelectionViewButtonsDisabled: boolean;
    scheduleViewButtonsDisabled: boolean;
    currentView: string;
    isScheduling?: boolean;
    setCurrentView: (arg1: string) => void;
    sendToText?: string;
    scheduledDate?: string;
    shouldHideAudienceSelection?: boolean;
};

export function PrepareToSendBreadcrumbs(props: Props) {
    const {
        prepareViewButtonsDisabled,
        audienceSelectionViewButtonsDisabled,
        scheduleViewButtonsDisabled,
        currentView,
        setCurrentView,
        isScheduling,
        sendToText,
        scheduledDate,
        shouldHideAudienceSelection,
    } = props;

    const audienceSelectionBreadcrumb = shouldHideAudienceSelection
        ? []
        : [
              {
                  id: 'recipients-selection',
                  title: 'Choose who to send to',
                  subtitle: sendToText,
                  selectable: !prepareViewButtonsDisabled,
              },
          ];

    const scheduleBreadcrumb = isScheduling
        ? [
              {
                  id: 'schedule',
                  title: 'Select a date & time',
                  subtitle: scheduledDate,
                  selectable: !prepareViewButtonsDisabled && !audienceSelectionViewButtonsDisabled,
              },
          ]
        : [];

    const breadcrumbs: Breadcrumb[] = [
        {
            id: 'prepare',
            title: 'Check for required items',
            subtitle: 'Ready for sending',
            selectable: true,
        },
        ...audienceSelectionBreadcrumb,
        ...scheduleBreadcrumb,
        {
            id: 'review',
            title: `Review and ${isScheduling ? 'schedule' : 'send'}`,
            selectable:
                !prepareViewButtonsDisabled &&
                !audienceSelectionViewButtonsDisabled &&
                ((isScheduling && !scheduleViewButtonsDisabled) || !isScheduling),
        },
    ];

    return (
        <div className={styles['breadcrumbs-container']}>
            <NumberedBreadcrumbs
                breadcrumbs={breadcrumbs}
                selectedValue={currentView}
                onSelectValue={(view: string) => {
                    setCurrentView(view);
                }}
                onlyDisplaySubtitleWhenCompleted={true}
                subtitleSize='mini'
                subtitleColor='light'
            />
        </div>
    );
}
